export function initModal() {
  const teamMembers = document.querySelectorAll(".team-member__wrapper");

  teamMembers.forEach((wrapper) => {
    const openModalBtn = wrapper.querySelector('.openModalBtn');
    const modal = wrapper.querySelector('.team-modal--frontend');

    const closeButton = document.createElement('button');
    closeButton.className = 'team-modal__close modalCloseBtn';
    closeButton.innerHTML = '<span class="visually-hidden">close</span>';
    modal.querySelector('.team-modal__wrapper').appendChild(closeButton);

    function openModal() {
      modal.style.display = 'flex';
      document.body.style.overflow = 'hidden';
      modal.setAttribute('aria-expanded', 'true');
      modal.setAttribute('aria-modal', 'true');
      modal.setAttribute('role', 'dialog');
      closeButton.focus();
    }

    function closeModal() {
      modal.style.display = 'none';
      document.body.style.overflow = 'auto';
      modal.setAttribute('aria-expanded', 'false');
      modal.removeAttribute('aria-modal');
      modal.removeAttribute('role');
      modal.focus();
    }

    openModalBtn.addEventListener('click', openModal);
    closeButton.addEventListener('click', closeModal);

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeModal();
      }
    });
  });
}
